<div style="height: 483px;"
    [ngClass]="{'d-flex justify-content-center align-items-center': (httpService.getLoading('userProfileLoader')) || !user}">
    <div *ngIf="!(httpService.getLoading('userProfileLoader'))">
        <div *ngIf="!user" class="text-center py-5">
            <i class="fe fe-user-x fs-1 text-muted"></i>
            <p class="text-muted mt-3">{{ msg }}</p>
        </div>

        <div class="card rounded-4 m-0" *ngIf="user">
            <div class="card-dropdown dropdown" *ngIf="publicService.hasAnyPermission(['EDIT_USER', 'DELETE_USER'])">
                <div class="btn-group">
                    <span data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fe fe-more-vertical black-menu fs-2"></i>
                    </span>
                    <ul class="dropdown-menu dropdown-menu-end" *ngIf="user?.id != 1">
                        <li *ngIf="publicService.hasAnyPermission(['EDIT_USER'])">
                            <a class="dropdown-item" [routerLink]="['/users/edit-user/' + user.id]"
                                (click)="activeModal.close()">
                                <i class="fe fe-edit"></i>
                                <span>{{ 'Edit' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['INVITE_USER'])">
                            <a class="dropdown-item" (click)="invite()">
                                <i class="fe fe-send"></i>
                                <span>{{ 'Invite' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['VIEW_USER_REPORT'])">
                            <a class="dropdown-item" [routerLink]="['/users/' + user.id + '/report']">
                                (click)="activeModal.close()">
                                <i class="fe fe-bar-chart-2"></i>
                                <span>{{ 'ViewReport' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['RESET_USER_PASSWORD'])">
                            <a class="dropdown-item" (click)="resetPassword()">
                                <i class="fe fe-refresh-cw"></i>
                                <span>{{ 'ResetPassword' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['TAKE_SCREENSHOT'])">
                            <a class="dropdown-item" (click)="takeScreenshot()">
                                <i class="fe fe-camera"></i>
                                <span>{{ 'TakeScreenshot' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['TAKE_SCREENSHOT'])">
                            <a class="dropdown-item" (click)="viewScreenshots()">
                                <i class="fe fe-image"></i>
                                <span>{{ 'ViewScreenshots' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['CUSTOMIZE_USER_PERMISSIONS'])">
                            <a class="dropdown-item" (click)="customizePermissions()">
                                <i class="fe fe-lock"></i>
                                <span>{{ 'CustomizePermissions' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['CUSTOMIZE_USER_PERMISSIONS'])">
                            <a class="dropdown-item" (click)="resetCustomizedPermissions()">
                                <i class="fe fe-rotate-ccw"></i>
                                <span>{{ 'ResetCustomizedPermissions' | translate }}</span>
                            </a>
                        </li>

                        <li *ngIf="publicService.hasAllPermissions(['DELETE_USER'])">
                            <hr class="dropdown-divider">
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['DELETE_USER'])">
                            <a class="dropdown-item delete-item" (click)="delete()">
                                <span>{{ 'Delete' | translate }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body pt-5 pb-3">
                <span class="avatar avatar-xl card-avatar" role="button"
                    (click)="publicService.openImage(user.full_name, user?.image)">
                    <img class="avatar-img rounded-circle" [lazyLoad]="user?.image"
                        [defaultImage]="'assets/img/no-user.png'" [errorImage]="'assets/img/no-user.png'"
                        style="box-shadow: 0px 0px 10px #00000025;">
                </span>
                <h2 class="text-center card-title">
                    {{ user.full_name || '-' }}
                </h2>
                <p class="text-center mb-4">
                    <span class="badge bg-primary-soft">{{ user?.job_description || '-' }}</span>
                    <span class="ms-1 badge bg-primary-soft">{{ user?.contract_type || '-' }}</span>
                </p>
                <div class="g-0 border-top border-bottom row">
                    <div class="py-4 text-center col-6">
                        <h6 class="text-uppercase text-muted">{{ 'Email' | translate }}</h6>
                        <h4 class="mb-0">{{ user?.company_email || user?.personal_email || '-' }}</h4>
                    </div>
                    <div class="py-4 text-center col-6 border-start">
                        <h6 class="text-uppercase text-muted">{{ 'JobDescription' | translate }}</h6>
                        <h4 class="mb-0">{{ user?.job_description || '-' }}</h4>
                    </div>
                </div>
                <div class="list-group-flush list-group">
                    <div class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col"><small>{{ 'Role' | translate }}</small></div>
                            <div class="col-auto">
                                <small class="text-muted">{{ user?.role || '-' }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col"><small>{{ 'Branch' | translate }}</small></div>
                            <div class="col-auto">
                                <small class="text-muted">{{ user?.branch || '-' }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col"><small>{{ 'Manager' | translate }}</small></div>
                            <div class="col-auto">
                                <small class="text-muted">{{ user?.manager?.name || '-' }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <span class="loader" *ngIf="(httpService.getLoading('userProfileLoader'))"></span>
</div>